<template>
  <div class="good-item">
    <el-checkbox :value="data.check" @change="handleCheckbox" />

    <div class="content">
      <img :src="data.imageUrl" alt="img.png" />
      <div class="info">
        <span class="title">{{ defaultTips(data.productName) }}</span>
        <span>{{ defaultTips(data.options) }}</span>
        <span>{{ $t('Order.Refund.Mobile.Components.GoodItem.ItemPrice') }}: ${{ amountTips(data.price) }}</span>
        <span>{{ $t('Order.Refund.Mobile.Components.GoodItem.Total') }}: ${{ amountTips(data.price * data.productNum).toFixed(2) }}</span>
        <span>{{ $t('Order.Refund.Mobile.Components.GoodItem.Quantity') }}: {{ amountTips(data.productNum) }}</span>
        <span style="color: red;">{{ $t('Order.Refund.Mobile.Components.GoodItem.RefundableAmount') }}: ${{ amountTips(skuRefundableAmount.toFixed(2)) }}</span>
        <div class="mobile-input-number">
          <MobileInputNumber ref="mobileInputNumber" :value="data.quantity" :min="0" :max="data.productNum" @change="onChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileInputNumber from '@/components/MobileInputNumber.vue'

export default {
  props: {
    // 商品数据
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  components: {
    MobileInputNumber
  },
  computed: {
    amountTips() {
      return (value) => value || 0
    },
    defaultTips() {
      return (value) => value || '-'
    },
    skuRefundableAmount() {
      return this.data.refundableAmount * this.data.quantity
    }
  },
  data() {
    return {
    }
  },
  methods: {
    /**
     * 复选框
     *
     * @param {Boolean} value 是否选中
     */
    handleCheckbox(value) {
      this.data.check = value
      if (value) {
        this.data.quantity = this.data.productNum
      } else {
        this.data.quantity = 0
      }
      this.$refs.mobileInputNumber.setNum(this.data.quantity)
      this.skuRefundableAmount = this.data.refundableAmount * this.data.quantity
      this.$emit('amount')
    },

    /**
     * 增加某个退款商品数量
     */
    onChange(value) {
      this.data.quantity = value
      if (value) {
        this.data.check = true
      } else {
        this.data.check = false
      }
      this.skuRefundableAmount = this.data.refundableAmount * this.data.quantity
      this.$emit('amount')
    },

    /**
     * 设置输入框的值
     *
     * @param {Number} value 需要设置的值
     */
    setNum(value) {
      this.$refs.mobileInputNumber.setNum(value)
    }
  }
}
</script>

<style lang="scss" scoped>
.good-item {
  display: flex;
  padding: 16px 0;
  border-bottom: 1px solid #dedede;
  .el-checkbox {
    margin-top: 32px;
    /deep/.el-checkbox__inner {
      width: 16px;
      height: 16px;
      border-radius: 8px;
      &::after {
        top: 2px;
        left: 5px;
      }
    }
  }
  .content {
    flex: 1;
    display: flex;
    margin-left: 8px;
    img {
      width: 80px;
      height: 80px;
      object-fit: cover;
      border-radius: 6px;
      vertical-align: middle;
    }
    .info {
      display: flex;
      color: #7b7b7b;
      font-size: 12px;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 8px;
      .title {
        color: #121212;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .mobile-input-number {
        margin-top: 3px;
      }
    }
  }
}
</style>
